import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ConsentService } from '../../core/consent/consent.service';

/**
 * The cookie banner.
 *
 * Rendered by the layout, so it appears on every public page. It is deliberately not a modal: it
 * does not trap focus, does not block scrolling and does not cover the content — a reader who
 * ignores it can still read the page, which is the behaviour that keeps it out of the way of both
 * visitors and crawlers.
 *
 * "Reject" is as prominent as "Accept". A banner where refusing is harder than agreeing is the
 * pattern regulators single out, and it is not worth the few extra consents.
 */
@Component({
  selector: 'app-cookie-banner',
  imports: [RouterLink],
  templateUrl: './cookie-banner.html',
  styleUrl: './cookie-banner.scss',
})
export class CookieBanner {
  private readonly consent = inject(ConsentService);

  protected readonly needsChoice = this.consent.needsChoice;

  protected acceptAll(): void {
    this.consent.acceptAll();
  }

  protected rejectAll(): void {
    this.consent.rejectAll();
  }

  protected acceptAnalyticsOnly(): void {
    this.consent.set({ analytics: true, advertising: false });
  }
}
